// extracted by mini-css-extract-plugin
export default {"container":"TopicIcon-module__container--u+ao8","bordered":"TopicIcon-module__bordered--6WSgM","animatedBackground":"TopicIcon-module__animatedBackground--wlvaS"};